import { render, staticRenderFns } from "./CarePlanTab.vue?vue&type=template&id=2d02d8b3&scoped=true"
import script from "./CarePlanTab.vue?vue&type=script&lang=ts"
export * from "./CarePlanTab.vue?vue&type=script&lang=ts"
import style0 from "./CarePlanTab.vue?vue&type=style&index=0&id=2d02d8b3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d02d8b3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d02d8b3')) {
      api.createRecord('2d02d8b3', component.options)
    } else {
      api.reload('2d02d8b3', component.options)
    }
    module.hot.accept("./CarePlanTab.vue?vue&type=template&id=2d02d8b3&scoped=true", function () {
      api.rerender('2d02d8b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyProjects/ClientTabsComponents/CarePlanTab.vue"
export default component.exports